import { FIRST_PARTY_APP_KEY } from '../apiConfig';

export default {
  async login(identifier, password) {
    return this.request('/auth/login', {
      method: 'POST',
      body: { identifier, password },
      headers: { 'X-First-Party-Key': FIRST_PARTY_APP_KEY },
    });
  },

  async recoveryResetPassword(identifier, recoveryCode, newPassword, confirmPassword) {
    return this.request('/auth/password/recovery-reset', {
      method: 'POST',
      body: {
        identifier,
        recovery_code: recoveryCode,
        new_password: newPassword,
        confirm_password: confirmPassword,
      },
      headers: { 'X-First-Party-Key': FIRST_PARTY_APP_KEY },
    });
  },

  async refreshToken() {
    return this.request('/auth/refresh', {
      method: 'POST',
      headers: { 'X-First-Party-Key': FIRST_PARTY_APP_KEY },
    });
  },

  async forceRefreshAccessToken() {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) {
      throw new Error('No refresh token available. Please log in again.');
    }

    const refreshed = await this._attemptRefresh(refreshToken);
    if (!refreshed) {
      throw new Error('Unable to refresh JWT. Please log in again.');
    }

    return localStorage.getItem('token');
  },

  // `redirectUri`: where the code is going. A 'dashboard' code is minted only for
  // Nucleus's own origin, because whoever holds it can exchange it for your tokens.
  async createLoginHandoffCode(audience, redirectUri) {
    return this.request('/auth/handoff', {
      method: 'POST',
      body: { audience, redirect_uri: redirectUri },
    });
  },

  async logout(scope = 'global') {
    const refreshToken = localStorage.getItem('refresh_token');
    return this.request('/auth/logout', {
      method: 'POST',
      body: { scope, ...(refreshToken ? { refresh_token: refreshToken } : {}) },
    });
  },

  // Lightweight session-liveness probe for idle polling; 401 = logged out elsewhere.
  async getSessionStatus() {
    return this.request('/auth/session/status');
  },

  async getMe() {
    return this.request('/auth/me');
  },

  // User Discovery
  async searchUsers(query, limit = 20) {
    const response = await this.request(`/users/search?q=${encodeURIComponent(query)}&limit=${limit}`);
    return response.users || [];
  },
};
